var chunkMapping = {
	"1036": [
		17031
	],
	"1295": [
		1295
	],
	"2567": [
		2567
	],
	"3457": [
		33457
	],
	"6655": [
		71455,
		92216
	],
	"7558": [
		27848,
		55508,
		66497
	],
	"8005": [
		63763
	],
	"8520": [
		98520
	],
	"8845": [
		48845
	]
};
var idToExternalAndNameMapping = {
	"1295": [
		"default",
		"./Actions",
		8726
	],
	"2567": [
		"default",
		"./hooks",
		28235
	],
	"17031": [
		"default",
		"./filters",
		22024
	],
	"27848": [
		"default",
		"./OktaAuthService",
		8726
	],
	"33457": [
		"default",
		"./Utils",
		8726
	],
	"48845": [
		"default",
		"./Store",
		8726
	],
	"55508": [
		"default",
		"./Routes",
		8726
	],
	"63763": [
		"default",
		"./mfsConfigurations",
		8726
	],
	"66497": [
		"default",
		"./Login",
		8726
	],
	"71455": [
		"default",
		"./game-picker",
		33836
	],
	"92216": [
		"default",
		"./app-sidebar",
		33836
	],
	"98520": [
		"default",
		"./Selectors",
		8726
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}